import {Injectable} from '@angular/core';
import {number} from '@amcharts/amcharts4/core';

@Injectable({
  providedIn: 'root'
})
export class TestService {

  constructor() { }

  bacteria100LevelToColorCategory(bacteriaLevel: number) {
    if (bacteriaLevel < 100) {
      // Below detection limit (< 100 CFU/ml)
      return 'Low';
    } else if (bacteriaLevel >= 100 && bacteriaLevel <= 500) {
      // Low (100 to 500 CFU/ml)
      return 'Low';
    } else if (bacteriaLevel > 500 && bacteriaLevel <= 2000) {
      // Low (500 to 2000 CFU/ml)
      return 'Low';
    } else if (bacteriaLevel > 2000 && bacteriaLevel <= 5000) {
      // Medium (2000 to 5000 CFU/ml)
      return 'Medium';
    } else if (bacteriaLevel > 5000) {
      // High (>5000 CFU/ml)
      return 'High';
    }
  }

  bacteriaLevelToColorCategory(bacteriaLevel: number) {
    if (bacteriaLevel < 500) {
      // Below detection limit (< 500 CFU/ml)
      return 'Low';
    } else if (bacteriaLevel >= 500 && bacteriaLevel < 10000) {
      // Medium (2000 to 5000 CFU/ml)
      return 'Medium';
    } else if (bacteriaLevel >= 10000) {
      // High (>5000 CFU/ml)
      return 'High';
    }
  }

  ecoliLevelToColorCategory(eColiLevel: number) {
    if (eColiLevel === 0 || eColiLevel === 1) {
      // Below detection limit 1 CFU/10ml<
      return 'Low';
    } else if (eColiLevel > 1 && eColiLevel < 100) {
      // Low (500 to 2000 CFU/ml)
      return 'Medium';
    } else if (eColiLevel > 100) {
      return 'High';
    }
  }

  h202AndChlorineLevelToColorCategory(disinfectantLevel: number) {
    if (disinfectantLevel < 10) {
      // H2O2 level: <10 PPM
      return 'Low';
    } else if (disinfectantLevel >= 10 && disinfectantLevel < 100) {
      return 'Medium';
    } else if (disinfectantLevel >= 100) {
      // H2O2 level: >100 PPM
      return 'High';
    }
  }

  getTestResultColor(testData) {
    if (testData.bacteriaLevel > 15000 ||
      testData.disinfectantLevel > 15000 ||
      testData.eColiLevel > 15000 ||
      testData.legionellaLevel > 15000) { }
    if (testData.testType === 'bacteria' && testData.bacteriaLevel >= 0 && testData.bacteriaLevel < 15000) {
      return this.bacteriaLevelToColorCategory(testData.bacteriaLevel);
    }
    if (testData.testType === 'bacteria_100' && testData.bacteriaLevel >= 0 && testData.bacteriaLevel < 15000) {
      return this.bacteria100LevelToColorCategory(testData.bacteriaLevel);
    }
    if (testData.testType === 'chlorine' && testData.disinfectantLevel >= 0 && testData.disinfectantLevel < 15000) {
      return this.h202AndChlorineLevelToColorCategory(testData.disinfectantLevel);
    }
    if (testData.testType === 'h2o2' && testData.disinfectantLevel >= 0 && testData.disinfectantLevel < 15000) {
      return this.h202AndChlorineLevelToColorCategory(testData.disinfectantLevel);
    }
    if (testData.testType === 'ecoli' && testData.eColiLevel >= 0 && testData.eColiLevel < 15000) {
      return this.ecoliLevelToColorCategory(testData.eColiLevel);
    }
    if (testData.testType === 'c19') {
      // TODO c19 color
    }
    if (testData.testType === 'legionella' && testData.legionellaLevel >= 0 && testData.legionellaLevel < 15000) {
      // TODO legionella color
    }
    if (testData.testType === 'unknown') {
      // TODO unknown return
    }
  }
}
